var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMotives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 569.55 51.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#232020;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.16,49.67h-8V10.31H58L33,41.69,8.18,10.31H8V49.67H0V1.53H10L33,30.62,56.22,1.53h9.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.15,25.53q0,11.84-9.71,19.15-8.5,6.39-21.14,6.38T116,44.61q-9.7-7.3-9.7-19.08,0-11.57,9.84-19Q124.79,0,137.3,0t21.08,6.52Q168.15,14,168.15,25.53Zm-8.31,0a16.19,16.19,0,0,0-7.18-13.69q-6.18-4.53-15.36-4.52-10,0-16.36,5.15a16.14,16.14,0,0,0-6.31,13.06,16.18,16.18,0,0,0,6.18,13.2q6.18,5,16.49,5t16.39-5A16.23,16.23,0,0,0,159.84,25.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.59,8.71h-23v41h-8v-41h-23V1.53h54Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.53,49.67h-8V1.53h8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.54,1.53,369.61,49.67h-9.17L334.51,1.53h8.91L365,41.64,386.63,1.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.91,49.67H430.52V1.53h48.53V8.71H438.49V21.08h28.2v7.18h-28.2V42.49h42.42Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M561.77,12.83A47.72,47.72,0,0,0,540,7.38q-7.38,0-11.31,1.73t-3.92,4.79c0,2.12,1.4,3.68,4.19,4.65A38.62,38.62,0,0,0,538.69,20q10,.67,13.17,1.07,9,1.2,13.36,4.45a10.9,10.9,0,0,1,4.33,9.25q0,7.63-6.79,11.83t-19.48,4.2q-18.42,0-28.65-8.11L519,36.9a45.9,45.9,0,0,0,24.34,6.92q8.45,0,13.1-2.33,4.45-2.27,4.45-6.18,0-4.59-5.85-6.12-3.06-.8-16.49-1.66-11.89-.81-16.69-3.2-5.58-2.77-5.58-9.37,0-6.78,6.35-10.7T540.56.33q15.56,0,26.06,7.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotives);
export default __webpack_public_path__ + "static/media/motives.917c1fd731456a1592e0b69a88947a33.svg";
export { ForwardRef as ReactComponent };